import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TenantsComponent} from './components/views/tenants/tenants.component';
import {DashboardComponent} from './components/views/dashboard/dashboard.component';
import {TenantDetailsComponent} from './components/views/tenant-form/tenant-details.component';
import {UserRightGroupListComponent} from './components/views/userrightgroup-list/userRightGroup-list.component';
import {UserRightGroupFormComponent} from './components/views/userrightgroup-form/userRightGroup-form.component';
import {GroupListComponent} from './components/views/groups/group-list.component';
import {GroupFormComponent} from './components/views/groupForm/group-form.component';
import {UserRightFormComponent} from './components/views/userright-form/userRight-form.component';
import {UserRightListComponent} from './components/views/userright-list/userRight-list.component';
import {UserListComponent} from './components/views/users/user-list.component';
import {UserFormComponent} from './components/views/user-form/user-form.component';
import {ModalWindowComponent} from './components/common/modal-window/modal-window';
import {ToolsComponent} from './components/views/tools/tools.component';
import {AdditionalRightListComponent} from './components/views/additionalright-list/additionalRight-list.component';
import {AdditionalRightFormComponent} from './components/views/additionalright-form/additionalRight-form.component';
import {AutomationMappingListComponent} from './components/views/automationmapping-list/automationMapping-list.component';
import {AutomationMappingFormComponent} from './components/views/automatiomapping-form/automationMapping-form.component';
import {RegoVivoMappingListComponent} from './components/views/regovivomapping-list/regoVivoMapping-list.component';
import {RegoVivoMappingFormComponent} from './components/views/regovivomapping-form/regoVivoMapping-form.component';
import {AboutComponent} from './components/views/about/about.component';
import {SuperuserComponent} from './components/application/superuser.component';
import { LoggedInGuard } from '../auth/logged-in-guard.service';

const routes: Routes = [
  // {path: '', pathMatch: 'prefix', redirectTo: 'about'},
  // https://github.com/angular/angular/issues/12648
  // in some cases, child routes will override root one's
  {
    path: 'superuser',
    component: SuperuserComponent,

    children: [
       {
        path: '',
        component: AboutComponent,
        canActivate: [LoggedInGuard]
       },
      {
        path: 'about',
        component: AboutComponent,
        canActivate: [LoggedInGuard]
      },
      {path: 'tenants', component: TenantsComponent, canActivate: [LoggedInGuard]},
      {path: 'tenants/:id', component: TenantsComponent, canActivate: [LoggedInGuard]},
      {path: 'dashboard', component: DashboardComponent, canActivate: [LoggedInGuard]},
      {path: 'tenant/:id', component: TenantDetailsComponent, canActivate: [LoggedInGuard]},
      {path: 'rightgroups', component: GroupListComponent, runGuardsAndResolvers: 'always', canActivate: [LoggedInGuard]},
      {path: 'rightgroups/:id', component: GroupListComponent, canActivate: [LoggedInGuard]},
      {path: 'rightgroup/:id', component: GroupFormComponent, canActivate: [LoggedInGuard]},
      {path: 'additionalrights', component: AdditionalRightListComponent, canActivate: [LoggedInGuard]},
      {path: 'additionalrights/:id', component: AdditionalRightListComponent, canActivate: [LoggedInGuard]},
      {path: 'additionalright/:id', component: AdditionalRightFormComponent, canActivate: [LoggedInGuard]},
      {path: 'grouprights', component: UserRightGroupListComponent, canActivate: [LoggedInGuard]},
      {path: 'grouprights/:id', component: UserRightGroupListComponent, canActivate: [LoggedInGuard]},
      {path: 'groupright/:id', component: UserRightGroupFormComponent, canActivate: [LoggedInGuard]},
      {path: 'userrights', component: UserRightListComponent, canActivate: [LoggedInGuard]},
      {path: 'userrights/:id', component: UserRightListComponent, canActivate: [LoggedInGuard]},
      {path: 'userright/:id', component: UserRightFormComponent, canActivate: [LoggedInGuard]},
      {path: 'users', component: UserListComponent, canActivate: [LoggedInGuard]},
      {path: 'users/:id', component: UserListComponent, canActivate: [LoggedInGuard]},
      {path: 'user/:id', component: UserFormComponent, canActivate: [LoggedInGuard]},
      {path: 'user/:id/', component: UserFormComponent, canActivate: [LoggedInGuard]},
      {path: 'automationmappings', component: AutomationMappingListComponent, canActivate: [LoggedInGuard]},
      {path: 'automationmappings/:id', component: AutomationMappingListComponent, canActivate: [LoggedInGuard]},
      {path: 'automationmapping/:id', component: AutomationMappingFormComponent, canActivate: [LoggedInGuard]},
      {path: 'regovivomappings', component: RegoVivoMappingListComponent, canActivate: [LoggedInGuard]},
      {path: 'regovivomappings/:id', component: RegoVivoMappingListComponent, canActivate: [LoggedInGuard]},
      {path: 'regovivomapping/:id', component: RegoVivoMappingFormComponent, canActivate: [LoggedInGuard]},
      {path: 'tools', component: ToolsComponent, canActivate: [LoggedInGuard]},
      // {path: 'callback', redirectTo: '/about', pathMatch: 'full', canActivate: [LoggedInGuard]},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), NgbModule],
  exports: [RouterModule]
})
export class SuperuserRoutingModule {
}
